export class QuantileTrendSeries {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "q",
            "baseName": "q",
            "type": "number",
            "format": "double"
        },
        {
            "name": "series",
            "baseName": "series",
            "type": "MetricTimeseries",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QuantileTrendSeries.attributeTypeMap;
    }
    constructor() {
    }
}
